import React from 'react';

const ToolsPage = React.lazy(() => import('../pages/tools/ToolsPage/ToolsPage'));

export const PATH_TOOLS = '/tools';

const PAGE_TOOLS = {
  component: ToolsPage,
  path: PATH_TOOLS,
};

export default [PAGE_TOOLS];
